import React from 'react'
import './Main.css'
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import ProductosMain from '../../Components/Admin/ProductosMain/ProductosMain'
import CardsCantidad from '../../Components/Admin/CardsCantidad/CardsCantidad'
import PlanInfoCard from '../../Components/Admin/PlanInfoCard/PlanInfoCard'
import TutorialDashboard from '../../Components/Onboarding/TutorialDashboard'
export default function Main() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='containerMain'>
                    <div className='deFLexMain'>
                        <CardsCantidad />
                    </div>
                    <div className='deFLexMain'>
                        <ProductosMain />
                        <PlanInfoCard />
                    </div>
                </div>
            </section>
            <TutorialDashboard />
        </div>
    )
}
